import SimpleInput from "./components/SimpleInput";
// import BasicForm from "./components/BasicForm";
function App() {
  return (
    <div className='app'>
      <SimpleInput />
      {/* <BasicForm /> */}
    </div>
  );
}

export default App;
